import {
    AvailablePlanType,
    COMMON_COVERAGE_CONFIG,
    LegalGender,
    PayerCoverageCheckNetwork,
} from "@common-shared/config/coverage.config"
import { AvailableCoverageHistorySortField } from "@common-shared/config/coverageHistory.config"
import { FeatureFlag } from "@common-shared/config/featureFlags.config"
import { COMMON_GENERAL_CONFIG } from "@common-shared/config/general.config"
import { COMMON_ONE_VERIFY_CHECKER_CONFIG } from "@common-shared/config/oneVerify/oneVerifyChecker.config"
import {
    COMMON_ONE_VERIFY_COVERAGE_CONFIG,
    CoverageBreakdownSection,
    CoveragePatientType,
    OneVerifyFlagType,
} from "@common-shared/config/oneVerify/oneVerifyCoverage.config"
import {
    COMMON_ONE_VERIFY_POLICIES_CONFIG,
    PoliciesListType,
    PolicyModality,
    PolicyModalityCode,
} from "@common-shared/config/oneVerify/oneVerifyPolicies.config"
import { IPolicyColumnConfiguration } from "@common-shared/types/policies.types"

export enum PolicyColumnKey {
    RESPONSE_TYPE = "RESPONSE_TYPE",
    OFFICE_ID = "OFFICE_ID",
    MODALITY_CODE = "MODALITY_CODE",
    MODALITY_CODE_UNMAPPED = "MODALITY_CODE_UNMAPPED",
    MEMBER_ID = "MEMBER_ID",
    PATIENT_FULL_NAME = "PATIENT_FULL_NAME",
    PATIENT_FIRST_NAME = "PATIENT_FIRST_NAME",
    PATIENT_LAST_NAME = "PATIENT_LAST_NAME",
    PATIENT_DOB = "PATIENT_DOB",
    PATIENT_TYPE = "PATIENT_TYPE",
    PATIENT_TYPE_UNMAPPED = "PATIENT_TYPE_UNMAPPED",
    PATIENT_ID = "PATIENT_ID",
    PATIENT_NEXT_APPOINTMENT_DATE = "PATIENT_NEXT_APPOINTMENT_DATE",
    PATIENT_STATE = "PATIENT_STATE",
    PATIENT_GENDER = "PATIENT_GENDER",
    PATIENT_GENDER_UNMAPPED = "PATIENT_GENDER_UNMAPPED",
    PATIENT_ADDRESS = "PATIENT_ADDRESS",
    PATIENT_ZIP_CODE = "PATIENT_ZIP_CODE",
    ADDITIONAL_POLICY_PAYER = "ADDITIONAL_POLICY_PAYER",
    ADDITIONAL_POLICY_MEMBER_ID = "ADDITIONAL_POLICY_MEMBER_ID",
    ADDITIONAL_POLICY_TYPE = "ADDITIONAL_POLICY_TYPE",
    ADDITIONAL_POLICY_TYPE_PLAN_TYPE = "ADDITIONAL_POLICY_TYPE_PLAN_TYPE",
    OVERRIDE_UPDATED_AT = "OVERRIDE_UPDATED_AT",
    OVERRIDE_EXPIRATION_DATE = "OVERRIDE_EXPIRATION_DATE",
    RELATIONSHIP_TO_SUBSCRIBER = "RELATIONSHIP_TO_SUBSCRIBER",
    SUBSCRIBER_NAME = "SUBSCRIBER_NAME",
    SUBSCRIBER_FIRST_NAME = "SUBSCRIBER_FIRST_NAME",
    SUBSCRIBER_LAST_NAME = "SUBSCRIBER_LAST_NAME",
    SUBSCRIBER_DOB = "SUBSCRIBER_DOB",
    SUBSCRIBER_MEMBER_ID = "SUBSCRIBER_MEMBER_ID",
    SUBSCRIBER_ADDRESS = "SUBSCRIBER_ADDRESS",
    SUBSCRIBER_GENDER = "SUBSCRIBER_GENDER",
    SUBSCRIBER_STATE = "SUBSCRIBER_STATE",
    SUBSCRIBER_ZIP_CODE = "SUBSCRIBER_ZIP_CODE",
    ELIGIBILITY_BEGIN_DATE = "ELIGIBILITY_BEGIN_DATE",
    ELIGIBILITY_END_DATE = "ELIGIBILITY_END_DATE",
    ELIGIBILITY_BEGIN_END_DATE = "ELIGIBILITY_BEGIN_END_DATE",
    ELIGIBILITY_TYPE = "ELIGIBILITY_TYPE",
    MEMBER_OBLIGATION = "MEMBER_OBLIGATION",
    PAYER_OBLIGATION = "PAYER_OBLIGATION",
    QMB_STATUS = "QMB_STATUS",
    THIRD_PARTY_PAYER = "THIRD_PARTY_PAYER",
    THIRD_PARTY_ADMINISTRATOR_NAME = "THIRD_PARTY_ADMINISTRATOR_NAME",
    THIRD_PARTY_ADMINISTRATOR_TYPE = "THIRD_PARTY_ADMINISTRATOR_TYPE",
    THIRD_PARTY_ADMINISTRATOR_PAYER_ID = "THIRD_PARTY_ADMINISTRATOR_PAYER_ID",
    BENEFIT_STRUCTURE = "BENEFIT_STRUCTURE",
    PLAN_NAME = "PLAN_NAME",
    PLAN_TYPE = "PLAN_TYPE",
    PLAN_STATUS = "PLAN_STATUS",
    PLAN_BEGIN_DATE = "PLAN_BEGIN_DATE",
    PLAN_END_DATE = "PLAN_END_DATE",
    PLAN_BEGIN_END_DATE = "PLAN_BEGIN_END_DATE",
    INSURANCE_TYPE = "INSURANCE_TYPE",
    GROUP_NAME = "GROUP_NAME",
    GROUP_ID = "GROUP_ID",
    COVERAGE_STATUS = "COVERAGE_STATUS",
    DENIAL_RISK = "DENIAL_RISK",
    ALERTS = "ALERTS",
    REQUESTED_PAYER = "REQUESTED_PAYER",
    IDENTIFIED_PAYER = "IDENTIFIED_PAYER",
    PAYER_ID = "PAYER_ID",
    COPAYMENT = "COPAYMENT",
    COINSURANCE = "COINSURANCE",
    TOTAL_DEDUCTIBLE = "TOTAL_DEDUCTIBLE",
    REMAINING_DEDUCTIBLE = "REMAINING_DEDUCTIBLE",
    TOTAL_OOP_MAX = "TOTAL_OOP_MAX",
    REMAINING_OOP_MAX = "REMAINING_OOP_MAX",
    NETWORK = "NETWORK",
    NETWORK_RAW = "NETWORK_RAW",
    PROVIDER = "PROVIDER",
    PROVIDER_NPI = "PROVIDER_NPI",
    PROVIDER_SESSION_CHARGE = "PROVIDER_SESSION_CHARGE",
    CPT_CODE = "CPT_CODE",
    DATE = "DATE",
    RESPONSE_STATUS = "RESPONSE_STATUS",
    REQUEST_ID = "REQUEST_ID",
    EHR_WRITE_STATUS = "EHR_WRITE_STATUS",
    RESULT_TYPE = "RESULT_TYPE",
    ERROR_CODE = "ERROR_CODE",
    ERROR_MESSAGE = "ERROR_MESSAGE",
    NETWORK_STATUS_ALERT = "NETWORK_STATUS_ALERT",
    NETWORK_STATUS_VERSION = "NETWORK_STATUS_VERSION",
    NETWORK_STATUS_RULE_ID = "NETWORK_STATUS_RULE_ID",
    REMAINING_SESSIONS_BEFORE_DEDUCTIBLE = "REMAINING_SESSIONS_BEFORE_DEDUCTIBLE",
    REMAINING_SESSIONS_BEFORE_OOP_MAX = "REMAINING_SESSIONS_BEFORE_OOP_MAX",
    RESET_BENEFITS_STATUS = "RESET_BENEFITS_STATUS",
    RESET_BENEFITS_DIFFERENCE = "RESET_BENEFITS_DIFFERENCE",
    RESET_BENEFITS_COINSURANCE = "RESET_BENEFITS_COINSURANCE",
    RESET_BENEFITS_COPAYMENT = "RESET_BENEFITS_COPAYMENT",
    RESET_BENEFITS_TOTAL_DEDUCTIBLE = "RESET_BENEFITS_TOTAL_DEDUCTIBLE",
    RESET_BENEFITS_TOTAL_OOP_MAX = "RESET_BENEFITS_TOTAL_OOP_MAX",
    RESET_BENEFITS_MEMBER_ID = "RESET_BENEFITS_MEMBER_ID",
    RESET_BENEFITS_PLAN_TYPE = "RESET_BENEFITS_PLAN_TYPE",
    RESET_BENEFITS_PLAN_NAME = "RESET_BENEFITS_PLAN_NAME",
    RESET_BENEFITS_INSURANCE_TYPE = "RESET_BENEFITS_INSURANCE_TYPE",
    RESET_BENEFITS_MEMBER_OBLIGATION = "RESET_BENEFITS_MEMBER_OBLIGATION",
    RESET_BENEFITS_BENEFIT_STRUCTURE = "RESET_BENEFITS_BENEFIT_STRUCTURE",
    RESET_BENEFITS_ADDITIONAL_POLICY_TYPE = "RESET_BENEFITS_ADDITIONAL_POLICY_TYPE",
    RESET_BENEFITS_ADDITIONAL_POLICY_PAYER = "RESET_BENEFITS_ADDITIONAL_POLICY_PAYER",
    RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID = "RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID",
    RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE = "RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE",
    RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME = "RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME",
    RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE = "RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE",
    RESET_BENEFITS_TELEHEALTH_COINSURANCE = "RESET_BENEFITS_TELEHEALTH_COINSURANCE",
    RESET_BENEFITS_TELEHEALTH_COPAYMENT = "RESET_BENEFITS_TELEHEALTH_COPAYMENT",
    RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE = "RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE",
    RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION = "RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION",
    POST_DEDUCTIBLE_SESSION_RATE = "POST_DEDUCTIBLE_SESSION_RATE",
    POST_OOM_MAX_SESSION_RATE = "POST_OOM_MAX_SESSION_RATE",
    PRIMARY_CARE_PHYSICIAN_NAME = "PRIMARY_CARE_PHYSICIAN_NAME",
    PRIMARY_CARE_PHYSICIAN_NPI = "PRIMARY_CARE_PHYSICIAN_NPI",
    PRIMARY_CARE_PHYSICIAN_ORGANIZATION = "PRIMARY_CARE_PHYSICIAN_ORGANIZATION",
    TELEHEALTH_COINSURANCE = "TELEHEALTH_COINSURANCE",
    TELEHEALTH_COPAYMENT = "TELEHEALTH_COPAYMENT",
    TELEHEALTH_BENEFIT_STRUCTURE = "TELEHEALTH_BENEFIT_STRUCTURE",
    TELEHEALTH_MEMBER_OBLIGATION = "TELEHEALTH_MEMBER_OBLIGATION",
    LATEST_COMMENT = "LATEST_COMMENT",
    MEDICARE_ADVANTAGE_PAYER_NAME = "MEDICARE_ADVANTAGE_PAYER_NAME",
    MEDICARE_ADVANTAGE_PAYER_ID = "MEDICARE_ADVANTAGE_PAYER_ID",
    MEDICARE_ADVANTAGE_MEMBER_ID = "MEDICARE_ADVANTAGE_MEMBER_ID",
    // DATA CORRECTIONS
    CORRECTED_PAYER_ID = "CORRECTED_PAYER_ID",
    CORRECTED_PATIENT_FIRST_NAME = "CORRECTED_PATIENT_FIRST_NAME",
    CORRECTED_PATIENT_LAST_NAME = "CORRECTED_PATIENT_LAST_NAME",
    CORRECTED_PATIENT_DOB = "CORRECTED_PATIENT_DOB",
    CORRECTED_MEMBER_ID = "CORRECTED_MEMBER_ID",
    REQUESTED_PAYER_ID = "REQUESTED_PAYER_ID",
    REQUESTED_PATIENT_FIRST_NAME = "REQUESTED_PATIENT_FIRST_NAME",
    REQUESTED_PATIENT_LAST_NAME = "REQUESTED_PATIENT_LAST_NAME",
    REQUESTED_MEMBER_ID = "REQUESTED_MEMBER_ID",
    REQUESTED_PATIENT_DOB = "REQUESTED_PATIENT_DOB",
    // MEDICAID SPECIFIC
    MANAGED_CARE_ORGANIZATION = "MANAGED_CARE_ORGANIZATION",
    // MODALITY SPECIFIC
    PRIOR_AUTHORIZATION = "PRIOR_AUTHORIZATION",
    TOTAL_VISITS = "TOTAL_VISITS",
    REMAINING_VISITS = "REMAINING_VISITS",
    AGENTIC_CHECK_STATUS = "AGENTIC_CHECK_STATUS",
    // TASKS
    TASK_ASSIGNMENT_ASSIGNEE = "TASK_ASSIGNMENT_ASSIGNEE",
    TASK_ASSIGNMENT_ASSIGNED_BY = "TASK_ASSIGNMENT_ASSIGNED_BY",
    TASK_ASSIGNMENT_DATE = "TASK_ASSIGNMENT_DATE",
    TASK_ASSIGNMENT_UPDATE_DATE = "TASK_ASSIGNMENT_UPDATE_DATE",
    TASK_ASSIGNMENT_STATUS = "TASK_ASSIGNMENT_STATUS",
    LAST_DONE_STATUS = "LAST_DONE_STATUS",
    LAST_DONE_AT = "LAST_DONE_AT",
    TASK_ASSIGNMENT_PRIORITY = "TASK_ASSIGNMENT_PRIORITY",
    // CUSTOM FIELDS FROM REQUEST
    APPOINTMENT_DATE = "APPOINTMENT_DATE",
    APPOINTMENT_TYPE = "APPOINTMENT_TYPE",
    OFFICE_NAME = "OFFICE_NAME",
    PROVIDER_NAME = "PROVIDER_NAME",
    REGION = "REGION",
    APPOINTMENT_STATUS = "APPOINTMENT_STATUS",
    CARRIER_NAME = "CARRIER_NAME",
    POLICY_ORDER = "POLICY_ORDER",
    APPOINTMENT_ID = "APPOINTMENT_ID",
    CREDENTIALING_STATUS = "CREDENTIALING_STATUS",
    WORKFLOW_STATUS = "WORKFLOW_STATUS",
    ENTRY_DATE = "ENTRY_DATE",
}

export enum ColumnValueCapitalizationLevel {
    EACH_WORD = "EACH_WORD",
    FIRST_WORD = "FIRST_WORD",
}

export const COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG = {
    unassignedColumnValue: "Unassigned",

    get columnsConfig(): Record<PolicyColumnKey, IPolicyColumnConfiguration> {
        return {
            [PolicyColumnKey.RESPONSE_TYPE]: {
                columnKey: PolicyColumnKey.RESPONSE_TYPE,
                label: "Check Type",
                source: "coverageResult",
                sourcePropertyPath: "responseType",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                formatting: {
                    enumMapping: COMMON_COVERAGE_CONFIG.responseTypeMapping,
                },
            },
            [PolicyColumnKey.MODALITY_CODE]: {
                columnKey: PolicyColumnKey.MODALITY_CODE,
                label: "Service",
                checkerExportLabel: "Service",
                source: "requestData",
                sourcePropertyPath: "modalityCode",
                width: 175,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_COVERAGE_CONFIG.modalityCodeDisplayNameMapping,
                },
            },
            [PolicyColumnKey.MODALITY_CODE_UNMAPPED]: {
                columnKey: PolicyColumnKey.MODALITY_CODE_UNMAPPED,
                label: "Service",
                checkerExportLabel: `Service. Options: ${Object.values(PolicyModalityCode).join("; ")}`,
                source: "requestData",
                sourcePropertyPath: "modalityCode",
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.MEMBER_ID]: {
                columnKey: PolicyColumnKey.MEMBER_ID,
                label: "Member ID",
                checkerExportLabel: "Member Id",
                source: "policy",
                sourcePropertyPath: "memberId",
                sortByField: AvailableCoverageHistorySortField.memberId,
                width: 150,
                mouseflowIgnore: true,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: false,
                },
            },
            [PolicyColumnKey.PATIENT_FULL_NAME]: {
                columnKey: PolicyColumnKey.PATIENT_FULL_NAME,
                label: "Patient Name",
                sortByField: AvailableCoverageHistorySortField.memberLastName,
                isCustomValue: true,
                width: 200,
                mouseflowIgnore: true,
                isEnabled: true,
                isDefaultColumn: true,
                isExportIgnored: true,
            },
            [PolicyColumnKey.PATIENT_FIRST_NAME]: {
                columnKey: PolicyColumnKey.PATIENT_FIRST_NAME,
                label: "Patient First Name",
                checkerExportLabel: "Member First Name",
                source: "coverageResult",
                sourcePropertyPath: "demographics.firstName",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "firstName",
                width: 200,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.PATIENT_LAST_NAME]: {
                columnKey: PolicyColumnKey.PATIENT_LAST_NAME,
                label: "Patient Last Name",
                checkerExportLabel: "Member Last Name",
                source: "coverageResult",
                sourcePropertyPath: "demographics.lastName",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "lastName",
                width: 200,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.PATIENT_DOB]: {
                columnKey: PolicyColumnKey.PATIENT_DOB,
                label: "Patient DOB",
                checkerExportLabel: "Member DOB",
                source: "policy",
                sourcePropertyPath: "memberDob",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "dob",
                width: 115,
                mouseflowIgnore: true,
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.PATIENT_TYPE]: {
                columnKey: PolicyColumnKey.PATIENT_TYPE,
                label: "Patient Type",
                checkerExportLabel: `Patient Type (optional). Options: ${Object.values(CoveragePatientType).join("; ")}`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "customerPatientType",
                width: 150,
                isEnabled: false,
                isDefaultColumn: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: false,
                },
                formatting: {
                    enumRenderedMapping:
                        COMMON_ONE_VERIFY_COVERAGE_CONFIG.selectRenderedPatientTypes,
                },
            },
            [PolicyColumnKey.PATIENT_TYPE_UNMAPPED]: {
                columnKey: PolicyColumnKey.PATIENT_TYPE_UNMAPPED,
                label: "Patient Type",
                checkerExportLabel: `Patient Type (optional). Options: ${Object.values(CoveragePatientType).join("; ")}`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "customerPatientType",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "customerPatientType",
                isEnabled: false,
            },
            [PolicyColumnKey.PATIENT_ID]: {
                columnKey: PolicyColumnKey.PATIENT_ID,
                label: "Patient ID",
                checkerExportLabel: "Patient ID (optional)",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "customerPatientId",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "customerPatientId",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.REPORTS]: false,
                    [PoliciesListType.PLAN_YEAR_RESETS]: true,
                    [PoliciesListType.MEDICAID]: true,
                },
            },
            [PolicyColumnKey.PATIENT_NEXT_APPOINTMENT_DATE]: {
                columnKey: PolicyColumnKey.PATIENT_NEXT_APPOINTMENT_DATE,
                label: "Next Appointment Date",
                checkerExportLabel: "Next Appointment Date (optional)",
                ignoreValueCapitalization: true,
                sortByField: AvailableCoverageHistorySortField.nextAppointment,
                source: "coverageResult",
                sourcePropertyPath: "customerPatientNextAppointmentDate",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath:
                    "customerPatientNextAppointmentDate",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.REPORTS]: true,
                    [PoliciesListType.MEDICAID]: true,
                },
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.PATIENT_STATE]: {
                columnKey: PolicyColumnKey.PATIENT_STATE,
                label: "Member State",
                checkerExportLabel:
                    "Member State (two-letter state abbreviation)",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "demographics.address.state",
                alternativeSource: "checkSpecificRequestData",
                alternativeSourcePropertyPath: "memberState",
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.PATIENT_ZIP_CODE]: {
                columnKey: PolicyColumnKey.PATIENT_ZIP_CODE,
                label: "Member ZIP Code",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "demographics.address.zip",
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.PATIENT_GENDER]: {
                columnKey: PolicyColumnKey.PATIENT_GENDER,
                label: "Member Gender",
                checkerExportLabel: `Member Gender. Options: ${Object.values(LegalGender).join("; ")}`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "demographics.gender",
                alternativeSource: "checkSpecificRequestData",
                alternativeSourcePropertyPath: "memberGender",
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    enumMapping: COMMON_ONE_VERIFY_CHECKER_CONFIG.genderMapping,
                },
            },
            [PolicyColumnKey.PATIENT_GENDER_UNMAPPED]: {
                columnKey: PolicyColumnKey.PATIENT_GENDER_UNMAPPED,
                label: "Member Gender",
                checkerExportLabel: `Member Gender. Options: ${Object.values(LegalGender).join("; ")}`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "demographics.gender",
                alternativeSource: "checkSpecificRequestData",
                alternativeSourcePropertyPath: "memberGender",
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.PATIENT_ADDRESS]: {
                columnKey: PolicyColumnKey.PATIENT_ADDRESS,
                label: "Member Address",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "demographics.address",
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    convertOnEmptyToUnknown: true,
                    address: true,
                },
            },
            [PolicyColumnKey.OVERRIDE_UPDATED_AT]: {
                columnKey: PolicyColumnKey.OVERRIDE_UPDATED_AT,
                label: "Override Updated At",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "override.updatedAt",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                listTypeEnabled: {
                    [PoliciesListType.REPORTS]: true,
                    [PoliciesListType.OVERRIDES]: true,
                },
            },
            [PolicyColumnKey.OVERRIDE_EXPIRATION_DATE]: {
                columnKey: PolicyColumnKey.OVERRIDE_EXPIRATION_DATE,
                label: "Override Expiration Date",
                ignoreValueCapitalization: true,
                sortByField:
                    AvailableCoverageHistorySortField.overrideExpirationDate,
                source: "coverageResult",
                sourcePropertyPath: "override.expirationDate",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                listTypeEnabled: {
                    [PoliciesListType.REPORTS]: true,
                    [PoliciesListType.OVERRIDES]: true,
                },
            },
            [PolicyColumnKey.RELATIONSHIP_TO_SUBSCRIBER]: {
                columnKey: PolicyColumnKey.RELATIONSHIP_TO_SUBSCRIBER,
                label: "Relationship to Subscriber",
                source: "coverageResult",
                sourcePropertyPath: "relationshipToSubscriber",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
            },
            [PolicyColumnKey.SUBSCRIBER_NAME]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_NAME,
                label: "Subscriber Name",
                isCustomValue: true,
                width: 200,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.SUBSCRIBER_FIRST_NAME]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_FIRST_NAME,
                label: "Subscriber First Name",
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.firstName",
                width: 200,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.SUBSCRIBER_LAST_NAME]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_LAST_NAME,
                label: "Subscriber Last Name",
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.lastName",
                width: 200,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.SUBSCRIBER_DOB]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_DOB,
                label: "Subscriber DOB",
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.dob",
                width: 115,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.SUBSCRIBER_MEMBER_ID]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_MEMBER_ID,
                label: "Subscriber Member ID",
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.memberId",
                width: 150,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.SUBSCRIBER_ADDRESS]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_ADDRESS,
                label: "Subscriber Address",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.address",
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    convertOnEmptyToUnknown: true,
                    address: true,
                },
            },
            [PolicyColumnKey.SUBSCRIBER_GENDER]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_GENDER,
                label: "Subscriber Gender",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.gender",
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    enumMapping: COMMON_ONE_VERIFY_CHECKER_CONFIG.genderMapping,
                },
            },
            [PolicyColumnKey.SUBSCRIBER_STATE]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_STATE,
                label: "Subscriber State",
                checkerExportLabel:
                    "Subscriber State (two-letter state abbreviation)",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.address.state",
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.SUBSCRIBER_ZIP_CODE]: {
                columnKey: PolicyColumnKey.SUBSCRIBER_ZIP_CODE,
                label: "Subscriber ZIP Code",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "subscriberDemographics.address.zip",
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.PLAN_STATUS]: {
                columnKey: PolicyColumnKey.PLAN_STATUS,
                label: "Plan Status",
                source: "coverageResult",
                sourcePropertyPath: "planStatus",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.HISTORY_SEARCH]: true,
                    [PoliciesListType.OVERRIDES]: true,
                    [PoliciesListType.PLAN_YEAR_RESETS]: true,
                    [PoliciesListType.MEDICAID]: true,
                },
                formatting: {
                    planStatus: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.planStatus",
                mouseflowIgnore: true,
            },
            [PolicyColumnKey.COVERAGE_STATUS]: {
                columnKey: PolicyColumnKey.COVERAGE_STATUS,
                label: "Coverage Status",
                source: "coverageResult",
                sourcePropertyPath: "modalityCoverageStatus",
                width: 175,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatOnEmptyColumn: true,
                formatting: {
                    modalityCoverageStatus: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath:
                    "override.modalityCoverageStatus",
            },
            [PolicyColumnKey.DENIAL_RISK]: {
                columnKey: PolicyColumnKey.DENIAL_RISK,
                label: "Denial Risk",
                source: "coverageResult",
                sourcePropertyPath: "flags",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    denialRisk: true,
                },
            },
            [PolicyColumnKey.ALERTS]: {
                columnKey: PolicyColumnKey.ALERTS,
                label: "Alert(s)",
                sortByField: AvailableCoverageHistorySortField.flags,
                source: "coverageResult",
                sourcePropertyPath: "flags",
                width: 300,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    flagsList: true,
                },
            },
            [PolicyColumnKey.REQUESTED_PAYER]: {
                columnKey: PolicyColumnKey.REQUESTED_PAYER,
                label: "Requested Payer",
                width: 275,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                isCustomValue: true,
            },
            [PolicyColumnKey.IDENTIFIED_PAYER]: {
                columnKey: PolicyColumnKey.IDENTIFIED_PAYER,
                label: "Identified Payer",
                width: 275,
                isEnabled: true,
                listTypeEnabled: {
                    [PoliciesListType.HISTORY_SEARCH]: false,
                    [PoliciesListType.OVERRIDES]: false,
                },
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                isCustomValue: true,
            },
            [PolicyColumnKey.PAYER_ID]: {
                columnKey: PolicyColumnKey.PAYER_ID,
                label: "Payer ID",
                checkerExportLabel:
                    "Payer Id (https://oneverify.meetnirvana.com/supported-payers/standard)",
                source: "responsePayer",
                sourcePropertyPath: "payerId",
                alternativeSource: "requestPayer",
                alternativeSourcePropertyPath: "payerId",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.NETWORK]: {
                columnKey: PolicyColumnKey.NETWORK,
                label: "Network",
                source: "coverageResult",
                sourcePropertyPath: "isInNetworkCheck",
                width: 100,
                isEnabled: false,
                listTypeEnabled: {
                    [PoliciesListType.HISTORY_SEARCH]: true,
                },
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                formatting: {
                    isInNetworkCheckMapped: true,
                },
            },
            [PolicyColumnKey.NETWORK_RAW]: {
                columnKey: PolicyColumnKey.NETWORK_RAW,
                label: "Network",
                checkerExportLabel: `Network (optional). Options: ${Object.values(PayerCoverageCheckNetwork).join("; ")}`,
                source: "coverageResult",
                sourcePropertyPath: "isInNetworkCheck",
                width: 100,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                formatting: {
                    isNetworkTypeValue: true,
                },
            },
            [PolicyColumnKey.PROVIDER]: {
                columnKey: PolicyColumnKey.PROVIDER,
                label: "Provider",
                source: "requestedHealthProvider",
                sourcePropertyPath: "name",
                alternativeSource: "requestData",
                alternativeSourcePropertyPath: "providerNpi",
                width: 235,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.PROVIDER_NPI]: {
                columnKey: PolicyColumnKey.PROVIDER_NPI,
                label: "Provider NPI",
                source: "requestData",
                sourcePropertyPath: "providerNpi",
                alternativeSource: "requestedHealthProvider",
                alternativeSourcePropertyPath: "npi",
                width: 235,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.PROVIDER_SESSION_CHARGE]: {
                columnKey: PolicyColumnKey.PROVIDER_SESSION_CHARGE,
                label: "Provider Session Cost",
                source: "requestData",
                sourcePropertyPath: "sessionCharge",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                },
            },
            [PolicyColumnKey.CPT_CODE]: {
                columnKey: PolicyColumnKey.CPT_CODE,
                label: "CPT Code",
                checkerExportLabel: "CPT Code (optional)",
                source: "requestData",
                sourcePropertyPath: "cptCode",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.DATE]: {
                columnKey: PolicyColumnKey.DATE,
                label: "Check Date",
                checkerExportLabel: "Time Stamp of the Coverage Check",
                source: "coverageResult",
                sourcePropertyPath: "createdAt",
                width: 175,
                isEnabled: false,
                listTypeEnabled: {
                    [PoliciesListType.HISTORY_SEARCH]: true,
                    [PoliciesListType.MEDICAID]: true,
                    [PoliciesListType.TASK_ASSIGNMENTS]: true,
                    [PoliciesListType.TASK_ASSIGNMENTS_EXTENDED_CUSTOM_FIELDS]: true,
                    [PoliciesListType.TASK_ASSIGNMENTS_MEDICAID]: true,
                    [PoliciesListType.ASSIGNED_TASKS]: true,
                    [PoliciesListType.ASSIGNED_TASKS_EXTENDED_CUSTOM_FIELDS]: true,
                    [PoliciesListType.ASSIGNED_TASKS_MEDICAID]: true,
                },
                isDefaultColumn: false,
                sortByField: AvailableCoverageHistorySortField.timestamp,
                formatting: {
                    dateFormat:
                        COMMON_GENERAL_CONFIG.defaultMomentDateTimeFormat,
                },
            },
            [PolicyColumnKey.RESPONSE_STATUS]: {
                columnKey: PolicyColumnKey.RESPONSE_STATUS,
                label: "Response Status",
                source: "coverageResult",
                sourcePropertyPath: "responseStatus",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.REQUEST_ID]: {
                columnKey: PolicyColumnKey.REQUEST_ID,
                label: "Request ID",
                checkerExportLabel: "Request Id",
                source: "coverageResult",
                sourcePropertyPath: "requestId",
                alternativeSource: "policy",
                alternativeSourcePropertyPath: "latestNirvanaRequestId",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.EHR_WRITE_STATUS]: {
                columnKey: PolicyColumnKey.EHR_WRITE_STATUS,
                label: "EHR Write Status",
                checkerExportLabel: "EHR Write Status",
                width: 180,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                isCustomValue: true,
                emptyColumnValue: "Not Written",
                formatOnEmptyColumn: true,
                featureFlags: [
                    FeatureFlag.ONE_VERIFY_EHR_WRITE_SINGLE,
                    FeatureFlag.ONE_VERIFY_EHR_WRITE_BULK,
                ],
                formatting: {
                    ehrWriteStatus: true,
                    enumMapping:
                        COMMON_ONE_VERIFY_POLICIES_CONFIG.oneVerifyEhrWriteStatusDisplay,
                },
            },
            [PolicyColumnKey.RESULT_TYPE]: {
                columnKey: PolicyColumnKey.RESULT_TYPE,
                label: "Result Type",
                source: "coverageResult",
                sourcePropertyPath: "resultType",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.ERROR_CODE]: {
                columnKey: PolicyColumnKey.ERROR_CODE,
                label: "Error Code",
                source: "coverageResult",
                sourcePropertyPath: "coverageError.code",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.ERROR_MESSAGE]: {
                columnKey: PolicyColumnKey.ERROR_MESSAGE,
                label: "Error Message",
                source: "coverageResult",
                sourcePropertyPath: "coverageError.message",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.NETWORK_STATUS_ALERT]: {
                columnKey: PolicyColumnKey.NETWORK_STATUS_ALERT,
                label: "Network Status Alert",
                checkerExportLabel: "Network Status Alert",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                isCustomValue: true,
                emptyColumnValue: "",
                featureFlags: [FeatureFlag.ONE_VERIFY_NETWORK_STATUS_RULES],
            },
            [PolicyColumnKey.NETWORK_STATUS_VERSION]: {
                columnKey: PolicyColumnKey.NETWORK_STATUS_VERSION,
                label: "Network Status Version",
                source: "coverageResult",
                sourcePropertyPath: "networkStatusAlert.rule.version.version",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                featureFlags: [FeatureFlag.ONE_VERIFY_NETWORK_STATUS_RULES],
            },
            [PolicyColumnKey.NETWORK_STATUS_RULE_ID]: {
                columnKey: PolicyColumnKey.NETWORK_STATUS_RULE_ID,
                label: "Network Status Rule ID",
                source: "coverageResult",
                sourcePropertyPath: "networkStatusAlert.rule.id",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                featureFlags: [FeatureFlag.ONE_VERIFY_NETWORK_STATUS_RULES],
            },
            [PolicyColumnKey.ELIGIBILITY_BEGIN_DATE]: {
                columnKey: PolicyColumnKey.ELIGIBILITY_BEGIN_DATE,
                label: "Eligibility Begin Date",
                source: "coverageResult",
                sourcePropertyPath: "eligibilityBeginDate",
                width: 150,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath:
                    "override.eligibilityBeginDate",
            },
            [PolicyColumnKey.ELIGIBILITY_END_DATE]: {
                columnKey: PolicyColumnKey.ELIGIBILITY_END_DATE,
                label: "Eligibility End Date",
                source: "coverageResult",
                sourcePropertyPath: "eligibilityEndDate",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.eligibilityEndDate",
            },
            [PolicyColumnKey.PLAN_BEGIN_DATE]: {
                columnKey: PolicyColumnKey.PLAN_BEGIN_DATE,
                label: "Plan Begin Date",
                source: "coverageResult",
                sourcePropertyPath: "planBeginDate",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.planBeginDate",
            },
            [PolicyColumnKey.PLAN_END_DATE]: {
                columnKey: PolicyColumnKey.PLAN_END_DATE,
                label: "Plan End Date",
                source: "coverageResult",
                sourcePropertyPath: "planEndDate",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                    [PoliciesListType.PLAN_YEAR_RESETS]: true,
                },
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.planEndDate",
            },
            [PolicyColumnKey.RESET_BENEFITS_STATUS]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_STATUS,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Benefits`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefitsStatus",
                emptyColumnValue: "Not Attempted",
                width: 200,
                mouseflowIgnore: false,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    resetBenefitStatus: true,
                },
            },
            [PolicyColumnKey.RESET_BENEFITS_DIFFERENCE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_DIFFERENCE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Differences`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits",
                width: 225,
                mouseflowIgnore: false,
                isEnabled: true,
                isDefaultColumn: true,
                // If the column is empty we will show either "None" or leave it empty depending on the resetBenefitsStatus, so handle this in the formatter
                formatOnEmptyColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    resetBenefitDifference: true,
                },
            },
            [PolicyColumnKey.RESET_BENEFITS_MEMBER_ID]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_MEMBER_ID,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Member ID`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.memberId",
                width: 150,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith: PolicyColumnKey.MEMBER_ID,
                resetBenefitsLabelOverride: "Member ID",
            },
            [PolicyColumnKey.RESET_BENEFITS_PLAN_NAME]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_PLAN_NAME,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Plan Name`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.planName",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                resetBenefitsCompareWith: PolicyColumnKey.PLAN_NAME,
                resetBenefitsLabelOverride: "Plan Name",
            },
            [PolicyColumnKey.RESET_BENEFITS_PLAN_TYPE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_PLAN_TYPE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Plan Type`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.planType",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_CHECKER_CONFIG.planTypeMapping,
                },
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith: PolicyColumnKey.PLAN_TYPE,
                resetBenefitsLabelOverride: "Plan Type",
            },
            [PolicyColumnKey.RESET_BENEFITS_INSURANCE_TYPE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_INSURANCE_TYPE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Insurance Type`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.insuranceType",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                resetBenefitsCompareWith: PolicyColumnKey.INSURANCE_TYPE,
                resetBenefitsLabelOverride: "Insurance Type",
                formatting: {
                    enumMapping:
                        COMMON_COVERAGE_CONFIG.availableInsuranceTypeMapping,
                },
            },
            [PolicyColumnKey.RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Third Party Administrator Name`,
                source: "coverageResult",
                sourcePropertyPath:
                    "resetBenefits.thirdPartyAdministrator.name",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith:
                    PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_NAME,
                resetBenefitsLabelOverride: "Name",
            },
            [PolicyColumnKey.RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Third Party Administrator Type`,
                source: "coverageResult",
                sourcePropertyPath:
                    "resetBenefits.thirdPartyAdministrator.type",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                resetBenefitsCompareWith:
                    PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_TYPE,
                resetBenefitsLabelOverride: "Type",
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_COVERAGE_CONFIG.availableThirdPartyPayerTypeMapping,
                },
            },
            [PolicyColumnKey.RESET_BENEFITS_TOTAL_DEDUCTIBLE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_TOTAL_DEDUCTIBLE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Deductible`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.deductible",
                width: 115,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                resetBenefitsCompareWith: PolicyColumnKey.TOTAL_DEDUCTIBLE,
                resetBenefitsLabelOverride: "Total Deductible",
            },
            [PolicyColumnKey.RESET_BENEFITS_TOTAL_OOP_MAX]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_TOTAL_OOP_MAX,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} OOP Maximum`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.oopMax",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                resetBenefitsCompareWith: PolicyColumnKey.TOTAL_OOP_MAX,
                resetBenefitsLabelOverride: "Total OOP Max",
            },
            [PolicyColumnKey.RESET_BENEFITS_COINSURANCE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_COINSURANCE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Coinsurance`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.coinsurance",
                width: 115,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    suffixValue: "%",
                },
                resetBenefitsCompareWith: PolicyColumnKey.COINSURANCE,
                resetBenefitsLabelOverride: "Coinsurance",
            },
            [PolicyColumnKey.RESET_BENEFITS_COPAYMENT]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_COPAYMENT,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Copayment`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.copayment",
                width: 115,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                resetBenefitsCompareWith: PolicyColumnKey.COPAYMENT,
                resetBenefitsLabelOverride: "Copayment",
            },
            [PolicyColumnKey.RESET_BENEFITS_BENEFIT_STRUCTURE]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_BENEFIT_STRUCTURE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Benefit Structure`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.benefitStructure",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith: PolicyColumnKey.BENEFIT_STRUCTURE,
                resetBenefitsLabelOverride: "Benefit Structure",
            },
            [PolicyColumnKey.RESET_BENEFITS_MEMBER_OBLIGATION]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_MEMBER_OBLIGATION,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Member Obligation`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.memberObligation",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                },
                resetBenefitsCompareWith: PolicyColumnKey.MEMBER_OBLIGATION,
                resetBenefitsLabelOverride: "Member Obligation",
            },
            [PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_PAYER]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_PAYER,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Additional Policy Payer`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.additionalPolicy.insurer",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                resetBenefitsCompareWith:
                    PolicyColumnKey.ADDITIONAL_POLICY_PAYER,
                resetBenefitsLabelOverride: "Payer",
            },
            [PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Additional Policy Member ID`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.additionalPolicy.memberId",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                resetBenefitsCompareWith:
                    PolicyColumnKey.ADDITIONAL_POLICY_MEMBER_ID,
                resetBenefitsLabelOverride: "Member ID",
            },
            [PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_TYPE]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_TYPE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Additional Policy Type`,
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.additionalPolicy.type",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                resetBenefitsCompareWith:
                    PolicyColumnKey.ADDITIONAL_POLICY_TYPE,
                resetBenefitsLabelOverride: "Policy Type",
            },
            [PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Additional Policy Plan Type`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.additionalPolicy.planType",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_CHECKER_CONFIG.planTypeMapping,
                },
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith:
                    PolicyColumnKey.ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
                resetBenefitsLabelOverride: "Plan Type",
            },
            [PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_COINSURANCE]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_COINSURANCE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Telehealth Coinsurance`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.telehealth.coinsurance",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    suffixValue: "%",
                },
                resetBenefitsCompareWith:
                    PolicyColumnKey.TELEHEALTH_COINSURANCE,
                resetBenefitsLabelOverride: "Coinsurance",
            },
            [PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_COPAYMENT]: {
                columnKey: PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_COPAYMENT,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Telehealth Copayment`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.telehealth.copayment",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                resetBenefitsCompareWith: PolicyColumnKey.TELEHEALTH_COPAYMENT,
                resetBenefitsLabelOverride: "Copayment",
            },
            [PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Telehealth Benefit Structure`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.telehealth.benefitStructure",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                resetBenefitsCompareWith:
                    PolicyColumnKey.TELEHEALTH_BENEFIT_STRUCTURE,
                resetBenefitsLabelOverride: "Benefit Structure",
            },
            [PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION]: {
                columnKey:
                    PolicyColumnKey.RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION,
                label: `${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetMonthAbbrv} ${COMMON_ONE_VERIFY_POLICIES_CONFIG.planYearResetsTargetYear} Telehealth Member Obligation`,
                source: "coverageResult",
                sourcePropertyPath: "resetBenefits.telehealth.memberObligation",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                },
                resetBenefitsCompareWith:
                    PolicyColumnKey.TELEHEALTH_MEMBER_OBLIGATION,
                resetBenefitsLabelOverride: "Member Obligation",
            },
            [PolicyColumnKey.POST_DEDUCTIBLE_SESSION_RATE]: {
                columnKey: PolicyColumnKey.POST_DEDUCTIBLE_SESSION_RATE,
                label: "Estimated Post Deductible Session Rate",
                source: "coverageResult",
                sourcePropertyPath: "postDeductibleMemberObligation",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    convertOnEmptyToUnknown: true,
                },
            },
            [PolicyColumnKey.POST_OOM_MAX_SESSION_RATE]: {
                columnKey: PolicyColumnKey.POST_OOM_MAX_SESSION_RATE,
                label: "Estimated Post Out-of-pocket Max Session Rate",
                source: "coverageResult",
                sourcePropertyPath: "postOopMaxMemberObligation",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                    convertOnEmptyToUnknown: true,
                },
            },
            [PolicyColumnKey.TELEHEALTH_COINSURANCE]: {
                columnKey: PolicyColumnKey.TELEHEALTH_COINSURANCE,
                label: "Telehealth Coinsurance",
                source: "coverageResult",
                sourcePropertyPath: "telehealth.coinsurance",
                width: 175,
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    suffixValue: "%",
                },
                listTypeEnabled: {
                    [PoliciesListType.PLAN_YEAR_RESETS]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection: CoverageBreakdownSection.TELEHEALTH,
                coverageBreakdownLabelOverride: "Coinsurance",
                coverageBreakdownEmptyValueTooltip:
                    "Some telehealth financial details aren’t available. This is normal and means those specific payment types don’t apply to your plan.",
            },
            [PolicyColumnKey.TELEHEALTH_COPAYMENT]: {
                columnKey: PolicyColumnKey.TELEHEALTH_COPAYMENT,
                label: "Telehealth Copayment",
                source: "coverageResult",
                sourcePropertyPath: "telehealth.copayment",
                width: 175,
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                listTypeEnabled: {
                    [PoliciesListType.PLAN_YEAR_RESETS]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection: CoverageBreakdownSection.TELEHEALTH,
                coverageBreakdownLabelOverride: "Copayment",
                coverageBreakdownEmptyValueTooltip:
                    "Some telehealth financial details aren’t available. This is normal and means those specific payment types don’t apply to your plan.",
            },
            [PolicyColumnKey.TELEHEALTH_BENEFIT_STRUCTURE]: {
                columnKey: PolicyColumnKey.TELEHEALTH_BENEFIT_STRUCTURE,
                label: "Telehealth Benefit Structure",
                source: "coverageResult",
                sourcePropertyPath: "telehealth.benefitStructure",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection: CoverageBreakdownSection.TELEHEALTH,
                coverageBreakdownLabelOverride: "Benefit Structure",
            },
            [PolicyColumnKey.TELEHEALTH_MEMBER_OBLIGATION]: {
                columnKey: PolicyColumnKey.TELEHEALTH_MEMBER_OBLIGATION,
                label: "Telehealth Member Obligation",
                source: "coverageResult",
                sourcePropertyPath: "telehealth.memberObligation",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    currency: true,
                    isCents: true,
                },
                // Coverage breakdown
                coverageBreakdownSection: CoverageBreakdownSection.TELEHEALTH,
                coverageBreakdownLabelOverride: "Member Obligation",
            },

            // DATA CORRECTIONS WITH REQUESTED COUNTERPARTS
            [PolicyColumnKey.CORRECTED_PAYER_ID]: {
                columnKey: PolicyColumnKey.CORRECTED_PAYER_ID,
                label: "Corrected Payer ID",
                checkerExportLabel:
                    "Corrected Payer ID (https://oneverify.meetnirvana.com/supported-payers/standard)",
                source: "responsePayer",
                sourcePropertyPath: "payerId",
                dataCompareWith: {
                    source: "requestPayer",
                    sourcePropertyPath: "payerId",
                },
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.CORRECTED_PATIENT_FIRST_NAME]: {
                columnKey: PolicyColumnKey.CORRECTED_PATIENT_FIRST_NAME,
                label: "Corrected Member First Name",
                source: "coverageResult",
                sourcePropertyPath: "demographics.firstName",
                dataCompareWith: {
                    source: "requestData",
                    sourcePropertyPath: "firstName",
                },
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.CORRECTED_PATIENT_LAST_NAME]: {
                columnKey: PolicyColumnKey.CORRECTED_PATIENT_LAST_NAME,
                label: "Corrected Member Last Name",
                source: "coverageResult",
                sourcePropertyPath: "demographics.lastName",
                dataCompareWith: {
                    source: "requestData",
                    sourcePropertyPath: "lastName",
                },
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.CORRECTED_MEMBER_ID]: {
                columnKey: PolicyColumnKey.CORRECTED_MEMBER_ID,
                label: "Corrected Member ID",
                source: "coverageResult",
                sourcePropertyPath: "demographics.memberId",
                dataCompareWith: {
                    source: "requestData",
                    sourcePropertyPath: "memberId",
                },
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
            },
            [PolicyColumnKey.CORRECTED_PATIENT_DOB]: {
                columnKey: PolicyColumnKey.CORRECTED_PATIENT_DOB,
                label: "Corrected Member DOB",
                source: "coverageResult",
                sourcePropertyPath: "demographics.dob",
                dataCompareWith: {
                    source: "requestData",
                    sourcePropertyPath: "dob",
                },
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.REQUESTED_PAYER_ID]: {
                columnKey: PolicyColumnKey.REQUESTED_PAYER_ID,
                label: "Requested Payer ID",
                source: "requestPayer",
                sourcePropertyPath: "payerId",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.REQUESTED_PATIENT_FIRST_NAME]: {
                columnKey: PolicyColumnKey.REQUESTED_PATIENT_FIRST_NAME,
                label: "Requested Member First Name",
                source: "requestData",
                sourcePropertyPath: "firstName",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.REQUESTED_PATIENT_LAST_NAME]: {
                columnKey: PolicyColumnKey.REQUESTED_PATIENT_LAST_NAME,
                label: "Requested Member Last Name",
                source: "requestData",
                sourcePropertyPath: "lastName",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.REQUESTED_MEMBER_ID]: {
                columnKey: PolicyColumnKey.REQUESTED_MEMBER_ID,
                label: "Requested Member ID",
                source: "requestData",
                sourcePropertyPath: "memberId",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
            },
            [PolicyColumnKey.REQUESTED_PATIENT_DOB]: {
                columnKey: PolicyColumnKey.REQUESTED_PATIENT_DOB,
                label: "Requested Member DOB",
                source: "requestData",
                sourcePropertyPath: "dob",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isExportSpecific: true,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            // MODALITY SPECIFIC
            [PolicyColumnKey.PRIOR_AUTHORIZATION]: {
                columnKey: PolicyColumnKey.PRIOR_AUTHORIZATION,
                isModalitySpecific: true,
                label: "Prior Authorization",
                source: "coverageResult",
                sourcePropertyPath: "priorAuthorization",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                isMedicaidCheckerExportIgnored: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_COVERAGE_CONFIG.availablePriorAuthorizationMapping,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.SPECIALTY_SPECIFIC,
            },
            [PolicyColumnKey.TOTAL_VISITS]: {
                columnKey: PolicyColumnKey.TOTAL_VISITS,
                isModalitySpecific: true,
                label: "Total Visits",
                source: "coverageResult",
                sourcePropertyPath: "visitsTotal",
                width: 115,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidCheckerExportIgnored: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.SPECIALTY_SPECIFIC,
            },
            [PolicyColumnKey.REMAINING_VISITS]: {
                columnKey: PolicyColumnKey.REMAINING_VISITS,
                isModalitySpecific: true,
                label: "Remaining Visits",
                source: "coverageResult",
                sourcePropertyPath: "visitsRemaining",
                width: 115,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidCheckerExportIgnored: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.SPECIALTY_SPECIFIC,
            },

            // COVERAGE BREAKDOWN GENERAL - order matters unless overridden
            [PolicyColumnKey.MANAGED_CARE_ORGANIZATION]: {
                columnKey: PolicyColumnKey.MANAGED_CARE_ORGANIZATION,
                label: "MCO",
                source: "coverageResult",
                sourcePropertyPath: "managedCareOrganization",
                width: 200,
                isEnabled: true,
                isDefaultColumn: true,
                mouseflowIgnore: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: false,
                },
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                coverageBreakdownOrder: 2,
                isMedicaidSpecific: true,
            },
            [PolicyColumnKey.PLAN_BEGIN_END_DATE]: {
                columnKey: PolicyColumnKey.PLAN_BEGIN_END_DATE,
                label: "Plan Begin-End Date",
                width: 275,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                mouseflowIgnore: true,
                isCustomValue: true,
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: [
                    "override.planBeginDate",
                    "override.planEndDate",
                ],
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.PLAN_TYPE]: {
                columnKey: PolicyColumnKey.PLAN_TYPE,
                label: "Plan Type",
                source: "coverageResult",
                sourcePropertyPath: "planType",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                    [PoliciesListType.MEDICAID]: true,
                },
                mouseflowIgnore: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_CHECKER_CONFIG.planTypeMapping,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.planType",
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                isMedicaidApplicable: true,
                flaggedFieldOnMatch: [
                    {
                        field: AvailablePlanType.MEDICARE_ADVANTAGE,
                        tooltip:
                            COMMON_ONE_VERIFY_POLICIES_CONFIG.flagTypeMappings[
                                OneVerifyFlagType.MEDICARE_ADVANTAGE
                            ].tooltip || "",
                    },
                    {
                        field: AvailablePlanType.MANAGED_MEDICAID,
                        tooltip:
                            COMMON_ONE_VERIFY_POLICIES_CONFIG.flagTypeMappings[
                                OneVerifyFlagType.MANAGED_MEDICAID
                            ].tooltip || "",
                    },
                ],
            },
            [PolicyColumnKey.PLAN_NAME]: {
                columnKey: PolicyColumnKey.PLAN_NAME,
                label: "Plan Name",
                source: "coverageResult",
                sourcePropertyPath: "planName",
                sortByField: AvailableCoverageHistorySortField.planName,
                width: 175,
                isEnabled: true,
                isDefaultColumn: true,
                mouseflowIgnore: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: false,
                    [PoliciesListType.MEDICAID]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.ELIGIBILITY_BEGIN_END_DATE]: {
                columnKey: PolicyColumnKey.ELIGIBILITY_BEGIN_END_DATE,
                label: "Eligibility Dates",
                width: 275,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                mouseflowIgnore: true,
                isCustomValue: true,
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: [
                    "override.eligibilityBeginDate",
                    "override.eligibilityEndDate",
                ],
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.ELIGIBILITY_TYPE]: {
                columnKey: PolicyColumnKey.ELIGIBILITY_TYPE,
                label: "Eligibility Type",
                source: "coverageResult",
                sourcePropertyPath: "eligibilityType",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: true,
                },
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                isMedicaidSpecific: true,
            },
            [PolicyColumnKey.GROUP_NAME]: {
                columnKey: PolicyColumnKey.GROUP_NAME,
                label: "Group Name",
                source: "coverageResult",
                sourcePropertyPath: "groupName",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                showCoverageBreakdownErrorMode: true,
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.GROUP_ID]: {
                columnKey: PolicyColumnKey.GROUP_ID,
                label: "Group ID",
                source: "coverageResult",
                sourcePropertyPath: "groupId",
                width: 135,
                mouseflowIgnore: true,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
            },
            [PolicyColumnKey.INSURANCE_TYPE]: {
                columnKey: PolicyColumnKey.INSURANCE_TYPE,
                label: "Insurance Type",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "insuranceType",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_GENERAL,
                formatting: {
                    enumMapping:
                        COMMON_COVERAGE_CONFIG.availableInsuranceTypeMapping,
                },
            },

            // COVERAGE BREAKDOWN THIRD PARTY PAYER - order matters unless overridden
            [PolicyColumnKey.THIRD_PARTY_PAYER]: {
                // NOTE: This is a legacy column which we maintain because old system comments use it and would error without it; it has been replaced by THIRD_PARTY_ADMINISTRATOR_NAME
                columnKey: PolicyColumnKey.THIRD_PARTY_PAYER,
                label: "Third Party Payer",
                source: "coverageResult",
                sourcePropertyPath: "thirdPartyPayer",
                alternativeSource: "coverageResult",
                alternativeSourcePropertyPath: "thirdPartyAdministrator.name",
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_NAME]: {
                columnKey: PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_NAME,
                label: "Third Party Administrator Name",
                source: "coverageResult",
                sourcePropertyPath: "thirdPartyAdministrator.name",
                alternativeSource: "coverageResult",
                alternativeSourcePropertyPath: "thirdPartyPayer",
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath:
                    "override.thirdPartyAdministratorName",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_THIRD_PARTY,
                coverageBreakdownLabelOverride: "Name",
            },

            [PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_TYPE]: {
                columnKey: PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_TYPE,
                label: "Third Party Administrator Type",
                source: "coverageResult",
                sourcePropertyPath: "thirdPartyAdministrator.type",
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath:
                    "override.thirdPartyAdministratorType",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_THIRD_PARTY,
                coverageBreakdownLabelOverride: "Type",
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_COVERAGE_CONFIG.availableThirdPartyPayerTypeMapping,
                },
            },

            [PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_PAYER_ID]: {
                columnKey: PolicyColumnKey.THIRD_PARTY_ADMINISTRATOR_PAYER_ID,
                label: "Third Party Administrator Payer ID",
                checkerExportLabel:
                    "Third Party Administrator Payer Id (https://oneverify.meetnirvana.com/supported-payers/standard)",
                source: "coverageResult",
                sourcePropertyPath: "thirdPartyAdministrator.payerId",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            // COVERAGE BREAKDOWN MEDICARE ADVANTAGE
            [PolicyColumnKey.MEDICARE_ADVANTAGE_PAYER_NAME]: {
                columnKey: PolicyColumnKey.MEDICARE_ADVANTAGE_PAYER_NAME,
                label: "Medicare Advantage Payer Name",
                source: "coverageResult",
                sourcePropertyPath: "medicareAdvantage.payerName",
                width: 230,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_MEDICARE_ADVANTAGE,
                coverageBreakdownLabelOverride: "Payer Name",
                coverageBreakdownEmptyValue:
                    COMMON_ONE_VERIFY_COVERAGE_CONFIG.defaultFallbackCoverageDataValueUnknown,
            },
            [PolicyColumnKey.MEDICARE_ADVANTAGE_PAYER_ID]: {
                columnKey: PolicyColumnKey.MEDICARE_ADVANTAGE_PAYER_ID,
                label: "Medicare Advantage Nirvana Payer ID",
                source: "coverageResult",
                sourcePropertyPath: "medicareAdvantage.payerId",
                width: 260,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_MEDICARE_ADVANTAGE,
                coverageBreakdownLabelOverride: "Nirvana Payer ID",
                coverageBreakdownEmptyValue:
                    COMMON_ONE_VERIFY_COVERAGE_CONFIG.defaultFallbackCoverageDataValueUnknown,
            },
            [PolicyColumnKey.MEDICARE_ADVANTAGE_MEMBER_ID]: {
                columnKey: PolicyColumnKey.MEDICARE_ADVANTAGE_MEMBER_ID,
                label: "Medicare Advantage Member ID",
                source: "coverageResult",
                sourcePropertyPath: "medicareAdvantage.memberId",
                width: 220,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_MEDICARE_ADVANTAGE,
                coverageBreakdownLabelOverride: "Member ID",
                coverageBreakdownEmptyValue:
                    COMMON_ONE_VERIFY_COVERAGE_CONFIG.defaultFallbackCoverageDataValueUnknown,
            },

            // COVERAGE BREAKDOWN ADDITIONAL_POLICY_PAYER - order matters unless overridden
            [PolicyColumnKey.ADDITIONAL_POLICY_PAYER]: {
                columnKey: PolicyColumnKey.ADDITIONAL_POLICY_PAYER,
                label: "Additional Policy Payer",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "additionalPolicy.insurer",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_ADDITIONAL_POLICY,
                coverageBreakdownLabelOverride: "Payer",
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.ADDITIONAL_POLICY_MEMBER_ID]: {
                columnKey: PolicyColumnKey.ADDITIONAL_POLICY_MEMBER_ID,
                label: "Additional Policy Member ID",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "additionalPolicy.memberId",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_ADDITIONAL_POLICY,
                coverageBreakdownLabelOverride: "Member ID",
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.ADDITIONAL_POLICY_TYPE]: {
                columnKey: PolicyColumnKey.ADDITIONAL_POLICY_TYPE,
                label: "Additional Policy Type",
                ignoreValueCapitalization: true,
                source: "coverageResult",
                sourcePropertyPath: "additionalPolicy.type",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: false,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_ADDITIONAL_POLICY,
                coverageBreakdownLabelOverride: "Policy Type",
                isMedicaidApplicable: true,
            },
            [PolicyColumnKey.ADDITIONAL_POLICY_TYPE_PLAN_TYPE]: {
                columnKey: PolicyColumnKey.ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
                label: "Additional Policy Plan Type",
                source: "coverageResult",
                sourcePropertyPath: "additionalPolicy.planType",
                width: 175,
                isEnabled: false,
                isDefaultColumn: false,
                mouseflowIgnore: true,
                listTypeEnabled: {
                    [PoliciesListType.MEDICAID]: false,
                },
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_CHECKER_CONFIG.planTypeMapping,
                },
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_ADDITIONAL_POLICY,
                coverageBreakdownLabelOverride: "Plan Type",
                isMedicaidApplicable: true,
            },

            // COVERAGE BREAKDOWN FINANCIALS - order matters unless overridden
            [PolicyColumnKey.BENEFIT_STRUCTURE]: {
                columnKey: PolicyColumnKey.BENEFIT_STRUCTURE,
                label: "Benefit Structure",
                source: "coverageResult",
                sourcePropertyPath: "override.benefitStructure",
                alternativeSource: "coverageResult",
                alternativeSourcePropertyPath: "benefitStructure",
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.benefitStructure",
                width: 200,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                ignoreValueCapitalization: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
            },
            [PolicyColumnKey.COINSURANCE]: {
                columnKey: PolicyColumnKey.COINSURANCE,
                label: "Coinsurance",
                source: "coverageResult",
                sourcePropertyPath: "coinsurance",
                width: 115,
                isEnabled: true,
                isDefaultColumn: true,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.PLAN_YEAR_RESETS]: false,
                },
                formatting: {
                    suffixValue: "%",
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.coinsurance",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
                coverageBreakdownEmptyValueTooltip:
                    "Your plan may exclude either coinsurance or copay, but not both. This is standard for many insurance plans.",
            },
            [PolicyColumnKey.COPAYMENT]: {
                columnKey: PolicyColumnKey.COPAYMENT,
                label: "Copayment",
                source: "coverageResult",
                sourcePropertyPath: "copayment",
                width: 115,
                isEnabled: true,
                isDefaultColumn: true,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.PLAN_YEAR_RESETS]: false,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.copayment",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
                coverageBreakdownEmptyValueTooltip:
                    "Your plan may exclude either coinsurance or copay, but not both. This is standard for many insurance plans.",
            },
            [PolicyColumnKey.TOTAL_DEDUCTIBLE]: {
                columnKey: PolicyColumnKey.TOTAL_DEDUCTIBLE,
                label: "Deductible",
                checkerExportLabel: "Total Deductible",
                source: "coverageResult",
                sourcePropertyPath: "deductible",
                width: 115,
                isEnabled: false,
                listTypeEnabled: {
                    [PoliciesListType.HISTORY_SEARCH]: true,
                    [PoliciesListType.OVERRIDES]: true,
                },
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.deductible",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
            },
            [PolicyColumnKey.REMAINING_DEDUCTIBLE]: {
                columnKey: PolicyColumnKey.REMAINING_DEDUCTIBLE,
                label: "Remaining Deductible",
                source: "coverageResult",
                sourcePropertyPath: "remainingDeductible",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.remainingDeductible",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
            },
            [PolicyColumnKey.TOTAL_OOP_MAX]: {
                columnKey: PolicyColumnKey.TOTAL_OOP_MAX,
                label: "OOP Maximum",
                checkerExportLabel: "Total Out-of-pocket Max",
                source: "coverageResult",
                sourcePropertyPath: "oopMax",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.oopMax",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
            },
            [PolicyColumnKey.REMAINING_OOP_MAX]: {
                columnKey: PolicyColumnKey.REMAINING_OOP_MAX,
                label: "Remaining OOP Maximum",
                checkerExportLabel: "Remaining Out-of-pocket Max",
                source: "coverageResult",
                sourcePropertyPath: "remainingOopMax",
                width: 180,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                    showZeroFractionDigits: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.remainingOopMax",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_FINANCIALS,
                coverageBreakdownLabelOverride: "Remaining OOP Max",
            },

            // COVERAGE BREAKDOWN OBLIGATION - order matters unless overridden
            [PolicyColumnKey.MEMBER_OBLIGATION]: {
                columnKey: PolicyColumnKey.MEMBER_OBLIGATION,
                label: "Member Obligation",
                checkerExportLabel: "Estimated Member Obligation",
                source: "coverageResult",
                sourcePropertyPath: "memberObligation",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.memberObligation",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_OBLIGATION,
            },
            [PolicyColumnKey.PAYER_OBLIGATION]: {
                columnKey: PolicyColumnKey.PAYER_OBLIGATION,
                label: "Payer Obligation",
                checkerExportLabel: "Estimated Payer Obligation",
                source: "coverageResult",
                sourcePropertyPath: "payerObligation",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                listTypeEnabled: {
                    [PoliciesListType.OVERRIDES]: true,
                },
                formatting: {
                    currency: true,
                    isCents: true,
                },
                isHighlightedSource: "coverageResult",
                isHighlightedSourcePropertyPath: "override.payerObligation",
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_OBLIGATION,
            },
            [PolicyColumnKey.QMB_STATUS]: {
                columnKey: PolicyColumnKey.QMB_STATUS,
                label: "Qualified Medicare Beneficiary",
                source: "coverageResult",
                sourcePropertyPath: "qmbStatus",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                ignoreValueCapitalization: true,
                formatting: {
                    qmbStatus: true,
                },
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_OBLIGATION,
            },
            [PolicyColumnKey.REMAINING_SESSIONS_BEFORE_DEDUCTIBLE]: {
                columnKey: PolicyColumnKey.REMAINING_SESSIONS_BEFORE_DEDUCTIBLE,
                label: "Remaining Sessions before Deductible",
                checkerExportLabel:
                    "Estimated Remaining Sessions Before Deductible",
                source: "coverageResult",
                sourcePropertyPath: "remainingSessionsBeforeDeductible",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_OBLIGATION,
            },
            [PolicyColumnKey.REMAINING_SESSIONS_BEFORE_OOP_MAX]: {
                columnKey: PolicyColumnKey.REMAINING_SESSIONS_BEFORE_OOP_MAX,
                label: "Remaining Session before OOP Max",
                checkerExportLabel:
                    "Estimated Remaining Sessions Before Out-of-pocket Max",
                source: "coverageResult",
                sourcePropertyPath: "remainingSessionsBeforeOopMax",
                width: 135,
                isEnabled: false,
                isDefaultColumn: false,
                isMedicaidApplicable: true,
                // Coverage breakdown
                coverageBreakdownSection:
                    CoverageBreakdownSection.POLICY_OBLIGATION,
            },

            // EXTRA COLUMNS
            [PolicyColumnKey.OFFICE_ID]: {
                columnKey: PolicyColumnKey.OFFICE_ID,
                label: "Office ID",
                checkerExportLabel: "Office ID (optional)",
                source: "requestData",
                sourcePropertyPath: "officeId",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                ignoreValueCapitalization: true,
            },
            [PolicyColumnKey.AGENTIC_CHECK_STATUS]: {
                columnKey: PolicyColumnKey.AGENTIC_CHECK_STATUS,
                label: "Status",
                checkerExportLabel: "Status",
                source: "agenticCheck",
                sourcePropertyPath: "status",
                width: 250,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    agenticCheckStatus: true,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_ASSIGNEE]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_ASSIGNEE,
                label: "Assignee",
                source: "policy",
                sourcePropertyPath: "latestAssignment.assignee.name",
                width: 135,
                isEnabled: true,
                isDefaultColumn: true,
                formatOnEmptyColumn: true,
                formatting: {
                    taskAssignmentAssignee: true,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_ASSIGNED_BY]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_ASSIGNED_BY,
                label: "Assigned By",
                source: "policy",
                sourcePropertyPath: "latestAssignment.assignedBy.name",
                width: 135,
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.LATEST_COMMENT]: {
                columnKey: PolicyColumnKey.LATEST_COMMENT,
                label: "Latest Comment",
                source: "policy",
                sourcePropertyPath: "latestUserComment",
                width: 135,
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    latestComment: true,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_DATE]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_DATE,
                label: "Assigned Date",
                sortByField:
                    AvailableCoverageHistorySortField.assignmentCreatedAt,
                source: "policy",
                sourcePropertyPath: "latestAssignment.createdAt",
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    dateFormat:
                        COMMON_GENERAL_CONFIG.defaultMomentDateTimeFormat,
                },
                listTypeEnabled: {
                    [PoliciesListType.TASK_ASSIGNMENTS]: true,
                    [PoliciesListType.TASK_ASSIGNMENTS_EXTENDED_CUSTOM_FIELDS]: true,
                    [PoliciesListType.TASK_ASSIGNMENTS_MEDICAID]: true,
                    [PoliciesListType.ASSIGNED_TASKS]: true,
                    [PoliciesListType.ASSIGNED_TASKS_EXTENDED_CUSTOM_FIELDS]: true,
                    [PoliciesListType.ASSIGNED_TASKS_MEDICAID]: true,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_UPDATE_DATE]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_UPDATE_DATE,
                label: "Last Update",
                source: "policy",
                sourcePropertyPath: "latestAssignment.updatedAt",
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_STATUS]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_STATUS,
                label: "Status",
                source: "policy",
                sourcePropertyPath: "latestAssignment.status",
                sortByField: AvailableCoverageHistorySortField.assignmentStatus,
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    // enumMapping is set dynamically in getColumnsConfiguration based on listType
                },
            },
            [PolicyColumnKey.LAST_DONE_AT]: {
                columnKey: PolicyColumnKey.LAST_DONE_AT,
                label: "Last Done",
                source: "policy",
                sourcePropertyPath: "latestDoneAssignment.updatedAt",
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    dateFormat: COMMON_GENERAL_CONFIG.defaultMomentDateFormat,
                },
            },
            [PolicyColumnKey.LAST_DONE_STATUS]: {
                columnKey: PolicyColumnKey.LAST_DONE_STATUS,
                label: "Last Done Status",
                source: "policy",
                sourcePropertyPath: "latestDoneAssignment.status",
                width: 100,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    // enumMapping is set dynamically in getColumnsConfiguration based on listType
                },
            },

            // REQUEST CUSTOM FIELDS
            [PolicyColumnKey.APPOINTMENT_DATE]: {
                columnKey: PolicyColumnKey.APPOINTMENT_DATE,
                label: "Appointment Date",
                source: "requestData",
                sourcePropertyPath: "customerPatientNextAppointmentDate",
                width: 150,
                sortByField: AvailableCoverageHistorySortField.nextAppointment,
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    appointmentDate: true,
                },
            },
            [PolicyColumnKey.APPOINTMENT_TYPE]: {
                columnKey: PolicyColumnKey.APPOINTMENT_TYPE,
                label: "Appointment Type",
                source: "requestData",
                sourcePropertyPath: "customFields.appointmentType",
                sortByField:
                    AvailableCoverageHistorySortField.customFieldAppointmentType,
                isEnabled: true,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.OFFICE_NAME]: {
                columnKey: PolicyColumnKey.OFFICE_NAME,
                label: "Office Name",
                source: "requestData",
                sourcePropertyPath: "customFields.officeName",
                sortByField:
                    AvailableCoverageHistorySortField.customFieldOfficeName,
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.PROVIDER_NAME]: {
                columnKey: PolicyColumnKey.PROVIDER_NAME,
                label: "Provider Name",
                isCustomValue: true,
                source: "requestData",
                sourcePropertyPath: "customFields.provider",
                sortByField: AvailableCoverageHistorySortField.providerName,
                isEnabled: true,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.REGION]: {
                columnKey: PolicyColumnKey.REGION,
                label: "Region",
                source: "requestData",
                sourcePropertyPath: "customFields.region",
                sortByField:
                    AvailableCoverageHistorySortField.customFieldRegion,
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.APPOINTMENT_STATUS]: {
                columnKey: PolicyColumnKey.APPOINTMENT_STATUS,
                label: "Appointment Status",
                source: "requestData",
                sourcePropertyPath: "customFields.appointmentStatus",
                sortByField:
                    AvailableCoverageHistorySortField.customFieldAppointmentStatus,
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.CARRIER_NAME]: {
                columnKey: PolicyColumnKey.CARRIER_NAME,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldCarrierName,
                label: "Primary Carrier Name",
                source: "requestData",
                sourcePropertyPath: "customFields.carrierName",
                alternativeSource: "requestData",
                isEnabled: true,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.POLICY_ORDER]: {
                columnKey: PolicyColumnKey.POLICY_ORDER,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldPolicyOrder,
                label: "Policy Order",
                width: 150,
                source: "requestData",
                sourcePropertyPath: "customFields.policyOrder",
                alternativeSource: "requestData",
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.APPOINTMENT_ID]: {
                columnKey: PolicyColumnKey.APPOINTMENT_ID,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldAppointmentId,
                label: "Appointment ID",
                width: 150,
                source: "requestData",
                sourcePropertyPath: "customFields.appointmentId",
                alternativeSource: "requestData",
                isEnabled: false,
                isDefaultColumn: true,
            },
            [PolicyColumnKey.CREDENTIALING_STATUS]: {
                columnKey: PolicyColumnKey.CREDENTIALING_STATUS,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldCredentialingStatus,
                label: "Credentialing Status",
                width: 150,
                source: "requestData",
                sourcePropertyPath: "customFields.credentialingStatus",
                isEnabled: true,
                isDefaultColumn: true,
                valueCapitalizationLevel:
                    ColumnValueCapitalizationLevel.FIRST_WORD,
            },
            [PolicyColumnKey.WORKFLOW_STATUS]: {
                columnKey: PolicyColumnKey.WORKFLOW_STATUS,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldWorkflowStatus,
                label: "Workflow Status",
                width: 150,
                source: "requestData",
                sourcePropertyPath: "customFields.workflowStatus",
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    enumMapping:
                        COMMON_ONE_VERIFY_POLICIES_CONFIG.policyAssignmentWorkflowStatusMapping,
                },
            },
            [PolicyColumnKey.ENTRY_DATE]: {
                columnKey: PolicyColumnKey.ENTRY_DATE,
                sortByField:
                    AvailableCoverageHistorySortField.customFieldAppointmentCreatedTimestamp,
                label: "Entry Date",
                width: 150,
                source: "requestData",
                sourcePropertyPath: "customFields.appointmentCreatedTimestamp",
                isEnabled: true,
                isDefaultColumn: true,
                formatting: {
                    dateFormat:
                        COMMON_GENERAL_CONFIG.defaultMomentDateTimeFormat,
                },
            },
            [PolicyColumnKey.TASK_ASSIGNMENT_PRIORITY]: {
                columnKey: PolicyColumnKey.TASK_ASSIGNMENT_PRIORITY,
                label: "Priority",
                source: "policy",
                sourcePropertyPath: "latestAssignment.priority",
                sortByField:
                    AvailableCoverageHistorySortField.assignmentPriority,
                width: 150,
                isEnabled: true,
                isDefaultColumn: true,
                ignoreValueCapitalization: true,
                formatting: {
                    priority: true,
                },
            },
            [PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_NAME]: {
                columnKey: PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_NAME,
                label: "PCP Name",
                source: "coverageResult",
                sourcePropertyPath: "primaryCarePhysician.name",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                coverageBreakdownSection:
                    CoverageBreakdownSection.PRIMARY_CARE_PHYSICIAN,
                coverageBreakdownLabelOverride: "Name",
            },
            [PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_NPI]: {
                columnKey: PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_NPI,
                label: "PCP NPI",
                source: "coverageResult",
                sourcePropertyPath: "primaryCarePhysician.npi",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                coverageBreakdownSection:
                    CoverageBreakdownSection.PRIMARY_CARE_PHYSICIAN,
                coverageBreakdownLabelOverride: "NPI",
            },
            [PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_ORGANIZATION]: {
                columnKey: PolicyColumnKey.PRIMARY_CARE_PHYSICIAN_ORGANIZATION,
                label: "PCP Organization",
                source: "coverageResult",
                sourcePropertyPath: "primaryCarePhysician.organization",
                width: 150,
                isEnabled: false,
                isDefaultColumn: false,
                coverageBreakdownSection:
                    CoverageBreakdownSection.PRIMARY_CARE_PHYSICIAN,
                coverageBreakdownLabelOverride: "Organization",
            },
        }
    },

    get modalitySpecificColumns(): Record<
        PolicyModality,
        IPolicyColumnConfiguration[]
    > {
        return {
            [PolicyModality.MENTAL_HEALTH]: [],
            [PolicyModality.EVALUATION_MANAGEMENT]: [],
            [PolicyModality.PHYSICAL_THERAPY]: [
                COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                    .PRIOR_AUTHORIZATION,
                COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                    .TOTAL_VISITS,
                COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                    .REMAINING_VISITS,
            ],
            [PolicyModality.MEDICAL_NUTRITION_THERAPY]: [],
            [PolicyModality.HOME_SLEEP_THERAPY]: [],
            [PolicyModality.MRI]: [],
            [PolicyModality.COMPUTED_TOMOGRAPHY]: [],
            [PolicyModality.INTENSIVE_OUTPATIENT_PROGRAM]: [],
            [PolicyModality.PARTIAL_HOSPITALIZATION_PROGRAM]: [],
            [PolicyModality.APPLIED_BEHAVIORAL_ANALYSIS]: [],
            [PolicyModality.OBSTETRICS_GYNECOLOGY]: [],
            [PolicyModality.MATERNITY]: [],
            [PolicyModality.ORTHOPEDICS]: [],
            [PolicyModality.DERMATOLOGY]: [],
            [PolicyModality.GASTROENTEROLOGY]: [],
            [PolicyModality.SPEECH_THERAPY]: [],
            [PolicyModality.CARDIOLOGY]: [],
            [PolicyModality.OCCUPATIONAL_THERAPY]: [],
            [PolicyModality.LABORATORY]: [],
            // TODO: remove this comment after coverage api is updated
            // Currently unsupported modalities in coverage api
            [PolicyModality.SUBSTANCE_USE_DISORDER]: [],
            [PolicyModality.URGENT_CARE]: [],
            [PolicyModality.ENDOCRINOLOGY]: [],
            [PolicyModality.NEPHROLOGY]: [],
            [PolicyModality.NEUROLOGY]: [],
            [PolicyModality.PULMONOLOGY]: [],
            [PolicyModality.UROLOGY]: [],
            [PolicyModality.CHRONIC_CARE_MANAGEMENT]: [],
        }
    },

    get dataCorrectionColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CORRECTED_PAYER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CORRECTED_PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CORRECTED_PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CORRECTED_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CORRECTED_PATIENT_DOB,
        ]
    },

    get resetBenefitsPolicyDetailsColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_INSURANCE_TYPE,
        ]
    },

    get resetBenefitsTpaColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE,
        ]
    },

    get resetBenefitsFinancialsColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_MEMBER_OBLIGATION,
        ]
    },

    get resetBenefitsAdditionalPolicyColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE,
        ]
    },

    get resetBenefitsTelehealthColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION,
        ]
    },

    get resetBenefitsColumns(): IPolicyColumnConfiguration[] {
        return [
            ...this.resetBenefitsPolicyDetailsColumns,
            ...this.resetBenefitsTpaColumns,
            ...this.resetBenefitsFinancialsColumns,
            ...this.resetBenefitsAdditionalPolicyColumns,
            ...this.resetBenefitsTelehealthColumns,
        ]
    },

    get reportsPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESPONSE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DENIAL_RISK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .EHR_WRITE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REQUESTED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_UPDATED_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_EXPIRATION_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PROVIDER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.REQUEST_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RELATIONSHIP_TO_SUBSCRIBER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PAYER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.QMB_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEDICARE_ADVANTAGE_PAYER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEDICARE_ADVANTAGE_PAYER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEDICARE_ADVANTAGE_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MANAGED_CARE_ORGANIZATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_VERSION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_STATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_ZIP_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_STATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_ZIP_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PRIMARY_CARE_PHYSICIAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PRIMARY_CARE_PHYSICIAN_NPI,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PRIMARY_CARE_PHYSICIAN_ORGANIZATION,
        ]
    },

    get medicaidReportsPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.REQUEST_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .EHR_WRITE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MANAGED_CARE_ORGANIZATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_BEGIN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
        ]
    },

    get historicalPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESPONSE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_UPDATED_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_EXPIRATION_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REQUESTED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RELATIONSHIP_TO_SUBSCRIBER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PAYER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_VERSION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
        ]
    },

    get overridesPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_UPDATED_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_EXPIRATION_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PAYER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REQUESTED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RELATIONSHIP_TO_SUBSCRIBER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
        ]
    },

    get planYearResetsPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_DIFFERENCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REQUESTED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_TELEHEALTH_MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_UPDATED_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_EXPIRATION_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_TYPE_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RELATIONSHIP_TO_SUBSCRIBER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PAYER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RESET_BENEFITS_BENEFIT_STRUCTURE,
        ]
    },

    get overridesPreviewPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
        ]
    },

    get agenticReportsPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .AGENTIC_CHECK_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DENIAL_RISK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_NEXT_APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REQUESTED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MODALITY_CODE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PLAN_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_BEGIN_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PLAN_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .INSURANCE_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.GROUP_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_END_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_UPDATED_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .OVERRIDE_EXPIRATION_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_DEDUCTIBLE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TOTAL_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .REMAINING_OOP_MAX,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.NETWORK,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PROVIDER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .THIRD_PARTY_ADMINISTRATOR_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ADDITIONAL_POLICY_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .RELATIONSHIP_TO_SUBSCRIBER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .SUBSCRIBER_MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PAYER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.QMB_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .MANAGED_CARE_ORGANIZATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .ELIGIBILITY_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COPAYMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_COINSURANCE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_BENEFIT_STRUCTURE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TELEHEALTH_MEMBER_OBLIGATION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
        ]
    },

    get taskAssignmentPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNEE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_UPDATE_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_PRIORITY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LAST_DONE_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LAST_DONE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LATEST_COMMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNED_BY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_VERSION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
        ]
    },

    get assignedTasksPoliciesColumns(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_UPDATE_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_PRIORITY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNEE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LATEST_COMMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNED_BY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_VERSION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
        ]
    },

    get taskAssignmentPoliciesColumnsExtendedCustomFields(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNEE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_UPDATE_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .WORKFLOW_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_PRIORITY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ENTRY_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CARRIER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .POLICY_ORDER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PROVIDER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LAST_DONE_AT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LAST_DONE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LATEST_COMMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.REGION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CREDENTIALING_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNED_BY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
        ]
    },

    get assignedTasksPoliciesColumnsExtendedCustomFields(): IPolicyColumnConfiguration[] {
        return [
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ENTRY_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNEE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_UPDATE_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .WORKFLOW_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_PRIORITY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FULL_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_LAST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PATIENT_FIRST_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.PATIENT_DOB,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_TYPE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CARRIER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .POLICY_ORDER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .IDENTIFIED_PAYER,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.MEMBER_ID,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.OFFICE_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .PROVIDER_NAME,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .LATEST_COMMENT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.ALERTS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig.REGION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .COVERAGE_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .APPOINTMENT_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .CREDENTIALING_STATUS,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_ASSIGNED_BY,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .TASK_ASSIGNMENT_DATE,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_ALERT,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_VERSION,
            COMMON_ONE_VERIFY_POLICIES_COLUMNS_CONFIG.columnsConfig
                .NETWORK_STATUS_RULE_ID,
        ]
    },
}
